import isEqual from 'lodash/isEqual'
import isNil from 'lodash/isNil'
import isUndefined from 'lodash/isUndefined'
import template from 'lodash/template'
import pick from 'lodash/pick'
import keys from 'lodash/keys'
import { md5 } from 'js-md5'
import dbg from 'debug'

import { commandMapToProtocol, protocolsName } from './protobuf/protocolbuf'

import {
  getWsHkAddress,
  getWsHsAddress,
  getWsUsAddress,
  getWsUsOptionAddress,
  getWsUsOtcAddress,
  getWsJpAddress
} from '../api'

const wsLog = dbg('f10:ws')

export const commandsName = {
  0: '心跳',

  1: '快照',
  2: '快照',

  3: '逐笔',
  4: '逐笔',

  5: '挂单',
  6: '挂单',

  7: '分时',
  8: '分时',

  9: 'K线',
  10: 'K线',

  12: '经纪席位',
  13: '经纪席位',

  16: '资金流向',
  17: '资金流向',

  18: '扩展行情',
  19: '扩展行情',

  20: '指数行情',
  21: '指数行情',

  24: '板块',
  25: '板块',

  26: '排行榜',
  27: '排行榜',

  28: '交易统计',
  29: '交易统计',

  30: '交易状态',
  31: '交易状态',

  32: '经纪排名',
  33: '经纪排名',

  34: '权证扩展行情',
  35: '权证扩展行情',

  36: '市场溢价',
  37: '市场溢价',

  38: '看涨看跌比例',
  39: '看涨看跌比例',

  40: '资金成交统计',
  41: '资金成交统计'
}

function messageCreater(params) {
  return JSON.stringify({
    version: '1.0.0',
    token: generateToken(params.command ?? 0),
    ...params
  })
}

export const generateToken = (command, appid = 'fenlibao', password = '123456') => {
  const timestamp = new Date().getTime()
  const tokenString = `${command}&${appid}&${timestamp}&${password}`
  const md5Token = md5(tokenString)
  const result = `${appid}&${md5Token}&${timestamp}`
  return result
}

function keyCreater(protocolCode, val, order = []) {
  const { symbol, symbols } = val
  let res = []
  const keyGen = (_symbol) => `${protocolCode}${_symbol}${order.reduce((_res, curr) => `${_res}${curr}`, '')}`
  if (symbols) {
    res = symbols.map((_symbol) => ({
      key: keyGen(_symbol),
      params: { ...val, symbols: [_symbol] }
    }))
  } else if (symbol) {
    res = [{ key: keyGen(symbol), params: val }]
  } else {
    res = [
      {
        key: `${order.reduce((_res, curr) => `${_res}${curr}`, '')}`,
        params: val
      }
    ]
  }

  return res
}

/**
 * 约定针对值为如下的字段或没有目标字段的情况，前端不取
 * 用该字段的值进行覆盖，即：无视该字段，
 * 1. -9999
 * 2. null
 *
 * TODO: 与 remapKeys 方法重复？是否需要合并？
 */
function mergeIgnoreInvalid(res) {
  return Object.entries(res).reduce((newRes, [key, value]) => {
    if (!isNil(value) && !isEqual(value, -9999)) {
      newRes[key] = value
    }
    return newRes
  }, {})
}

const handlerSymbolKey = (val, protocolCode) => keyCreater(protocolCode, val)

const handlerSymbolsKey = (val, protocolCode) => {
  const { symbol, symbols } = val
  let res = []
  if (symbols) {
    res = symbols.map((_symbol) => {
      const key = protocolCode + _symbol
      return { key, params: { ...val, symbols: [_symbol] } }
    })
  } else if (symbol) {
    res = [{ key: protocolCode + symbol, params: { command: 0 } }]
  }
  return res
}

const msgHandlerMap = {
  1000: {
    protocolName: 'HeartBeat',
    handler: () =>
      // console.log(val)
      []
  },
  1001: {
    protocolName: 'Snap',
    handler: handlerSymbolsKey
  },
  1002: {
    protocolName: 'OrderStr',
    handler: handlerSymbolsKey
  },
  1003: {
    protocolName: 'Trade',
    handler: handlerSymbolKey
  },
  1004: {
    protocolName: 'Trend',
    handler: (val, protocolCode) => {
      const { trendType = '' } = val
      return keyCreater(protocolCode, val, [trendType])
    }
  },
  1005: {
    protocolName: 'Kline',
    handler: (val, protocolCode) => {
      // console.log(val)
      const { type } = val
      return keyCreater(protocolCode, val, [type])
    }
  },
  // 订阅状态：成功/失败
  1006: {
    protocolName: 'Response',
    handler: () => []
  },
  1007: {
    protocolName: 'OrderBrokerStr',
    handler: handlerSymbolKey
  },
  1009: {
    protocolName: 'CapitalFlow',
    handler: handlerSymbolKey
  },
  1010: {
    protocolName: 'ExtendSnap',
    handler: handlerSymbolKey
  },
  1011: {
    protocolName: 'IndexQuote',
    handler: handlerSymbolKey
  },
  1013: {
    protocolName: 'IndustryRankList',
    handler: (val, protocolCode) => {
      // console.log(val);
      const { type, sum } = val
      return keyCreater(protocolCode, val, [type, sum])
    }
  },
  1014: {
    protocolName: 'RankList',
    handler: handlerSymbolKey
  },
  1015: {
    protocolName: 'TradeStatisticsList',
    handler: handlerSymbolKey
  },
  1016: {
    protocolName: 'StockStatus',
    handler: handlerSymbolKey
  },
  // 连接成功
  // 1017: {
  //   protocolName: '',
  //   handler: (val, protocolCode) => {
  //     // console.log(val)
  //     return []
  //   }
  // },
  1018: {
    protocolName: 'BrokerRankingList',
    handler: handlerSymbolKey
  },
  // 清盘标识
  1019: {
    protocolName: 'Liquidation',
    // handler: (val, protocolCode) =>
    handler: () =>
      // this.liquidation = true;
      //   setTimeout(() => {
      //     this.liquidation = false;
      //   }, 0);
      //   return;
      []
  },
  1020: {
    protocolName: 'WarrantQuote',
    handler: handlerSymbolKey
  },
  1021: {
    protocolName: 'MarketPremium',
    handler: handlerSymbolKey
  },
  1022: {
    protocolName: 'UnderlyingStatistics',
    handler: handlerSymbolsKey
  },
  2013: {
    protocolName: 'CapitalDistribute',
    handler: handlerSymbolKey
  }
}

// getWsHkAddress, getWsHsAddress, getWsUsAddress, getWsUsOptionAddress
const SOCKET_ADDRESS_NAME_MAP = {
  [getWsHkAddress()]: '港股串流',
  [getWsHsAddress()]: 'A 股串流',
  [getWsUsAddress()]: '美股串流',
  [getWsUsOptionAddress()]: '美股期权串流',
  [getWsUsOtcAddress()]: '美股OTC串流',
  [getWsJpAddress()]: '日股串流'
}

export default class WebSocketClass {
  url

  pbDecoder

  wsInstance

  heartBeatTimer

  reconnectTimer

  // 缓存当前订阅
  currSub

  constructor(url, pbDecoder) {
    this.url = url
    this.pbDecoder = pbDecoder
    this.currSub = {}

    this.initialSocket(this.url)
  }

  initialSocket(url) {
    this.wsInstance = new WebSocket(url)

    //! 待精准确认要设置的类型
    // this.wsInstance.binaryType = 'arraybuffer';

    this.wsInstance.onopen = () => {
      // console.log('onopen!连接成功。', this.wsInstance);
      this.clearReconnectTimer()
      this.startHeartBeat()

      // 如果open的时候已有currSub，即认为是重连或缓存
      if (keys(this.currSub).length > 0) {
        // 重放所有订阅
        keys(this.currSub).forEach((key) => {
          if (this.currSub?.[key]?.[0]?.params) {
            this.sendMessage(this.currSub[key][0].params)
          }
        })
      }
    }

    /**
     * response,
     * [
     *    "1006",
     *    {
     *       code: "200",
     *       msg: "subscribe underlying statistics success.",
     *       protocol: "1006"
     *    }
     * ]
     */
    this.wsInstance.onmessage = async (message) => {
      const [protocolCode, res] = await this.pbDecoder(message.data)

      if (protocolCode === '1006') {
        wsLog('通讯结果', res) // TODO:
        return
      }

      if (['1017', '1000', '1006'].includes(protocolCode)) return

      this.notify(res)
    }

    // TODO 关闭之前创建的实例，不该无限创建新的实例
    this.wsInstance.onerror = () => {
      wsLog(`\x1B[30;1m${SOCKET_ADDRESS_NAME_MAP[url]}\x1B[m %c连接出错`, 'color: red; font-weight: bold;')

      this.stopHeartBeat()
      this.reconnect()
    }

    // TODO: 具体是什么情况下，在 websocket 关闭后，还得重连，如何适配主动关闭 ws 的情况？
    // `event.code` 参见 https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent/code
    this.wsInstance.onclose = (event) => {
      wsLog(`${SOCKET_ADDRESS_NAME_MAP[url]} \x1B[30;9m连接关闭\x1B[m`, `状态码：${event.code}`)

      this.stopHeartBeat()
      this.reconnect()
    }
  }

  reconnect() {
    if (!this.reconnectTimer) {
      this.reconnectTimer = setTimeout(() => {
        wsLog(`\x1B[30;1m${SOCKET_ADDRESS_NAME_MAP[this.url]}\x1B[m \x1B[30;106;1m重连中...\x1B[m`)
        this.clearReconnectTimer()
        this.initialSocket(this.url)
      }, 3 * 1000)
    }
  }

  clearReconnectTimer() {
    clearTimeout(this.reconnectTimer)
    this.reconnectTimer = undefined
  }

  // 60 秒后，如果服务端与客户端没有活动，就断连，所以每 3 秒发起一次心跳
  startHeartBeat() {
    const heartBeatMessage = {
      command: 0,
      heartBeat: 'heartBeat'
    }

    this.heartBeatTimer = setInterval(() => {
      this.sendMessage(heartBeatMessage)
    }, 1000 * 3)
  }

  stopHeartBeat() {
    clearInterval(this.heartBeatTimer)
    this.heartBeatTimer = undefined
  }

  // TODO: 未正确输出日志，日志明文，以及原始结果
  notify(result) {
    wsLog('被 ws.send() 方法放入队列中但还没有被发送到网络中的数据字节数：', this.wsInstance?.bufferedAmount)

    // console.log('result', new Date, result);

    const { protocol } = result

    const [item] = msgHandlerMap[protocol].handler(result, protocol)

    wsLog('WebSocket Raw Response：', result)
    wsLog(
      getWsResponseMsg({
        protocol,
        stockSymbol: result.symbol,
        payload: mergeIgnoreInvalid(result)
      })
    )
    this.currSub[item?.key]?.forEach((sub) => {
      // mergeIgnoreInvalid 处理后端返回的奇怪的数据，详情参见函数定义位置的注释
      sub.callback(mergeIgnoreInvalid(result))
    })
  }

  sendMessage(params) {
    if (this.wsInstance?.readyState === 1) {
      this.wsInstance.send(messageCreater(params))
    }
  }

  subscribe(params, callback) {
    // console.log('params', params)
    // eslint-disable-next-line no-debugger
    // debugger;
    // 归一化请求

    const subID = Symbol(JSON.stringify(params))

    const { command } = params
    const protocolCode = commandMapToProtocol[command]
    const paramsFormatted = msgHandlerMap[protocolCode].handler(params, protocolCode)
    if (paramsFormatted.length === 0) return subID

    paramsFormatted.forEach((item) => {
      const temp = {
        params: item.params,
        callback,
        id: subID
      }

      if (this.currSub[item.key]) {
        this.currSub[item.key].push(temp)
      } else {
        this.currSub[item.key] = [temp]
      }
    })

    wsLog(getWsSubMsg(pick(params, ['symbol', 'command', 'symbols', 'timeMode', 'type'])))

    this.sendMessage(params)
    // console.log('f10:ws ', params, getWsSubMsg(pick(params, ['symbol', 'command', 'symbols', 'timeMode', 'type'])))

    return subID

    // return {
    //   // 两种方式：1.返回退订方法 2.返回唯一标识
    //   unsubscribe: () => {
    //     // 任何时候退订都要比较key和symbol
    //     const _protocolCode = protocolCode
    //     const _id = id
    //     const _params = params
    //     if(symbols) {
    //       // 有symbols的情况
    //       // 计算退订参数
    //       const _symbols = symbols

    //       // 寻找当时的订阅，并剔除
    //       this.currSub[_protocolCode][_id] = this.currSub[_protocolCode][_id].filter(sub => sub.subID !== subID)

    //       // 要记得引用计数，其他可能还有在订阅那只票的，计算实际退订参数
    //       const symbolList = symbols.map(symbol => {
    //         if(!this.currSub[_protocolCode][_id].symbols.includes(symbol)) return symbol
    //       });

    //       _params.symbols = symbolList
    //       _params.command = _params.command + 1
    //     } else {
    //       // 无symbols的情况

    //     }
    //     this.sendMessage(_params)
    //   }
    // }
  }

  unsubscribe({ params, subID = undefined }) {
    if (isUndefined(subID)) return

    const protocolCode = commandMapToProtocol[params.command]
    const paramsFormatted = msgHandlerMap[protocolCode].handler(params, protocolCode)

    paramsFormatted.forEach((item) => {
      if (this.currSub[item.key]) {
        this.currSub[item.key] = this.currSub[item.key].filter((sub) => sub.id !== subID)
      }

      if (this.currSub[item.key]?.length === 0) {
        if (!item.params.command) return

        const wsUnsubMsg = {
          ...item.params,

          // 退订的 command 是： "订阅的 command" + 1
          command: item.params.command + 1
        }

        wsLog(getWsUnsubMsg(pick(wsUnsubMsg, ['command', 'symbol', 'symbols', 'timeMode', 'type'])))

        // 发送真正的退订
        this.sendMessage(wsUnsubMsg)
      }
    })
  }
}
// ! differenceInSeconds 运行会报错，用 getSecondsDifference 替换
function getSecondsDifference(start, end) {
  const differenceInMilliseconds = start - end
  const differenceInSeconds = differenceInMilliseconds / 1000
  return differenceInSeconds
}
// AAPL.us 快照订阅返回：“{}”
function getWsResponseMsg(target) {
  const tpl = template(
    '↓ [交易所时间与客户端响应时间差：<%= exchangeClientTimeGap %>] <%= symbol %> <%= protocol %>订阅返回：<%= result %>;'
  )

  return tpl({
    exchangeClientTimeGap: target?.payload?.time
      ? `${getSecondsDifference(new Date(), new Date(target.payload.time))}s`
      : '未返回交易所时间',
    symbol: target.stockSymbol,
    protocol: protocolsName[target.protocol],
    result: JSON.stringify(target.payload)
  })
}

const timeModeString = {
  0: '实时',
  1: '延时'
}

function getWsSubMsg(target) {
  const tpl = template('↑ 订阅 <%= symbols %> <%= timeMode %><%= command %>! 订阅参数：<%= params %>')

  return tpl({
    symbols: target?.symbols?.join(',') ?? target?.symbol,
    command: commandsName[target?.command],
    timeMode: timeModeString[target.timeMode],
    params: JSON.stringify(target)
  })
}

// ✘ 关闭 "AAPL.us 实时快照" 订阅
function getWsUnsubMsg(target) {
  const tpl = template('✗ 关闭 <%= symbols %> <%= timeMode %><%= command %>! 退订参数：<%= params %>')
  return tpl({
    symbols: target?.symbols?.join(',') ?? target?.symbol,
    command: commandsName[target?.command],
    timeMode: timeModeString[target.timeMode],
    params: JSON.stringify(target)
  })
}
